import { useMemo } from "react";

import { GetPublicFocusAreaListForDashboardQuery } from "@/graphql/generated/graphql";
import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useQuery } from "@tanstack/react-query";

import { getPublicFocusAreaListForDashboardQueryDocument } from "./public-dashboard-embed.gql";

export const useGetPublicFocusAreasForDashboard = ({
  dashboardId,
  enabled = true,
}: {
  dashboardId: string;
  enabled?: boolean;
}) => {
  const queryResult = useQuery({
    queryKey: queryKeys.publicDashboards.focusAreas(dashboardId),
    queryFn: async (): Promise<GetPublicFocusAreaListForDashboardQuery> => {
      const client = createOperationClient("GetPublicFocusAreaListForDashboard", true, { dashboardId });
      return await client.request(getPublicFocusAreaListForDashboardQueryDocument, {
        input: { dashboardId },
      });
    },
    enabled: !!dashboardId && enabled,
    retry: false,
  });

  const focusAreaList = useMemo(() => {
    return queryResult.data?.publicFocusAreaListForDashboard ?? [];
  }, [queryResult.data]);

  return {
    focusAreaList,
    queryResult,
    loading: queryResult.isLoading,
    error: queryResult.error,
  };
};
